import { useLayoutEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { getUrlParam, getUrlWithParams } from 'core-components/helpers/url'
import { P360_PAGE_URL } from 'partner360/configs'

import { getIsOldViewKeptOnLoad } from './planningViewDefault'
import { NEW_VIEW_MODE_URL_PARAM_VALUE, VIEW_MODE_URL_PARAM_KEY } from './viewModeUrlParam'

/** The page layout picks its old or new widgets by `v` in the URL, so a partner page opened
 *  without it gets `v` written in before paint: mounted above the routes, it runs while the app is
 *  still loading and the old view never shows first. */
export const usePlanningDefaultViewRedirect = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useLayoutEffect(() => {
    const isPartnerPage = getUrlParam('page', pathname) === P360_PAGE_URL
    const hasViewMode = Boolean(getUrlParam(VIEW_MODE_URL_PARAM_KEY, pathname))

    if (isPartnerPage && !hasViewMode && !getIsOldViewKeptOnLoad()) {
      navigate(
        getUrlWithParams({ [VIEW_MODE_URL_PARAM_KEY]: NEW_VIEW_MODE_URL_PARAM_VALUE }, pathname),
        { replace: true }
      )
    }
  }, [navigate, pathname])
}
